import { createRouter, createWebHistory } from 'vue-router'

const HomeView = () => import('@/views/HomeView.vue')
const SecurityView = () => import('@/views/SecurityView.vue')
const AcordView = () => import('@/views/AcordView.vue')
const TermsView = () => import('@/views/TermsView.vue')
const PrivacyPolicyView = () => import('@/views/PrivacyPolicyView.vue')

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: {
        title: 'InforceIQ — Private Preview',
        description:
          'InforceIQ is building a reviewable operating layer for the work between insurance agency systems, with people in control.',
      },
    },
    {
      path: '/security',
      name: 'security',
      component: SecurityView,
      meta: {
        title: 'Security | InforceIQ',
        description: 'Security context for InforceIQ websites, applications, and related services.',
      },
    },
    {
      path: '/acord',
      name: 'acord',
      component: AcordView,
      meta: {
        title: 'ACORD Membership | InforceIQ',
        description:
          'InforceIQ is an ACORD member. Learn what that means for standards-aware insurance workflows.',
      },
    },
    {
      path: '/terms',
      name: 'terms',
      component: TermsView,
      meta: {
        title: 'Terms of Service | InforceIQ',
        description:
          'Public terms of service and end-user license agreement for access to the InforceIQ platform.',
      },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: PrivacyPolicyView,
      meta: {
        title: 'Privacy Policy | InforceIQ',
        description:
          'Public privacy policy for how InforceIQ collects, uses, and protects information.',
      },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
